import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { GET_DOMAIN_REDIRECT, callApi, postLogin } from '../utils';
import ErrorFallback from '../ErrorFallBackComponent';
import ExpiredSessionModal from './ExpiredSessionModal';

class StartSession extends Component {
  state = {
    error: '',
    errorInfo: '',
    hasError: false,
    open: false,
  };

  componentDidMount() {

    const queryParams = new URLSearchParams(this.props.location.search);

    const data = {
      domain: queryParams.get('domain'),
      authToken: queryParams.get('token'),
      channel: queryParams.get('channel'),
    };

    this.setState({ redirect: GET_DOMAIN_REDIRECT(data.domain) });

    if (!data.authToken) {
      this.setState({
        open: true,
        errorMessage: 'Sorry, we are unable to launch the app. Please try again after some time.',
      });
      return;
    }

    callApi('/sessions', data, 'post')
      .then((res) => {
        postLogin(this.props, res)
      })
      .catch((err) => {
        switch (err.message) {
          case 'Token expired':
            this.setState({
              open: true,
              errorMessage: 'Sorry, your session has expired. Please relaunch the app',
            });
            break;

          case 'Error Validating Token':
            this.setState({
              open: true,
              errorMessage: 'Sorry, your session has expired. Please relaunch the app',
            });
            break;

          case 'No Token Found':
            this.setState({
              open: true,
              errorMessage:
                'Sorry, we are unable to launch the app. Please try again after some time.',
            });
            break;

          default:
            this.setState({ open: true, errorMessage: 'Something bad happened' });
            break;
        }
      });
  }

  render() {
    const { hasError, errorInfo, error, open, errorMessage, redirect } = this.state;
    if (hasError) {
      return <ErrorFallback error={error} errorInfo={errorInfo} />;
    }
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <ExpiredSessionModal open={open} errorMessage={errorMessage} redirect={redirect} />
        Redirecting...
      </div>
    );
  }
}

export default connect((state) => ({ ...state.user }))(withRouter(StartSession))



// WEBPACK FOOTER //
// ./src/components/StartSession.js